import { commonCbEnv } from "./env.cb.common";

const env: Partial<typeof commonCbEnv> = {
  production: true,
  page: 'toate-produsele',
  meta: {
    siteTitle: 'Căruța cu bani - Cursuri',
    siteDescription: 'Căruța cu bani - Cursuri',
    ogSiteName: 'Căruța Cu Bani',
    ogUrl: 'https://carutacubani.ro/cursuri/lista/',
    ogImage: 'https://carutacubani.ro/cursuri/lista/assets/images/toate-produsele/logo-caruta-cu-bani.png',
    // ogImage: 'https://carutacubani.ro/cursuri/lista/assets/images/toate-produsele/blackfriday/bf-ccb-2025.jpg',
    ogImageAlt: 'Cursuri pentru libertate financiara prin investitii'
  }
};

export const environment = { ...commonCbEnv, ...env };
